import { world } from '../../languages';
import { isThisTimeFrameInBerlinNow } from '../date/berlin-time';
import serializeQueryParams from '../url/serialize-query-params';

const schedule = {
    checkSaleLastDay() {
        if (this.dates.salePeriod[world]) {
            const { start } = this.dates.saleLastDay[world];
            const { end } = this.dates.saleLastDay[world];
            const queryParams = serializeQueryParams();

            if (isThisTimeFrameInBerlinNow(start, end) || queryParams.lastSaleDay) {
                this.saleLastDay = true;
            }
        }
    },
    checkSalePeriod() {
        if (this.dates.salePeriod[world] && this.dates.saleLastDay[world]) {
            const { start } = this.dates.salePeriod[world];
            const { end } = this.dates.salePeriod[world];
            const queryParams = serializeQueryParams();

            if (isThisTimeFrameInBerlinNow(start, end) || queryParams.saleDays) {
                this.saleDays = true;
            }
        }
    },
    checkMagazinePeriod() {
        if (this.dates.magazinePeriod[world]) {
            const { start } = this.dates.magazinePeriod[world];
            const { end } = this.dates.magazinePeriod[world];
            const queryParams = serializeQueryParams();

            if (isThisTimeFrameInBerlinNow(start, end) || queryParams.democracy) {
                this.magazineDay = true;
            }
        }
    },
    dates: {
        saleLastDay: {
            de: {
                end: new Date(2025, 2, 11),
                start: new Date(2025, 2, 10)
            },
            es: {
                end: new Date(2025, 1, 25),
                start: new Date(2025, 1, 24)
            },
            // fr: {
            //     end: new Date(2024, 10, 20),
            //     start: new Date(2024, 10, 19)
            // },
            gr: {
                end: new Date(2025, 1, 25),
                start: new Date(2025, 1, 24)
            },
            it: {
                end: new Date(2025, 1, 25),
                start: new Date(2025, 1, 24)
            }
            // nl: {
            //     end: new Date(2024, 10, 20),
            //     start: new Date(2024, 10, 19)
            // }
        },
        salePeriod: {
            de: {
                end: new Date(2025, 2, 10),
                start: new Date(2025, 2, 9)
            },
            es: {
                end: new Date(2025, 1, 24),
                start: new Date(2025, 1, 23)
            },
            // fr: {
            //     end: new Date(2024, 10, 19),
            //     start: new Date(2024, 10, 17)
            // },
            gr: {
                end: new Date(2025, 1, 24),
                start: new Date(2025, 1, 23)
            },
            it: {
                end: new Date(2025, 1, 24),
                start: new Date(2025, 1, 23)
            }
            // nl: {
            //     end: new Date(2025, 0, 8),
            //     start: new Date(2025, 0, 5)
            // }
        },
        magazinePeriod: {
            de: {
                end: new Date(2025, 1, 29),
                start: new Date(2025, 1, 14, 12)
            }
        }
    },
    saleDays: false,
    saleLastDay: false,
    magazineDay: false,
    set() {
        this.checkSalePeriod();
        this.checkSaleLastDay();
        this.checkMagazinePeriod();
    }
};

export default schedule;
